import {ConfirmJoinView} from "./ConfirmJoin";

export default {
    "confirm-join": ConfirmJoinView
}